import React, { useState, useEffect } from 'react';
import '../catalogue/styles.css';
import img from './catalogue.jpg';
import pptxgen from 'pptxgenjs';
import img2 from './powerpoint.png';
import img3 from './excel.png';
import img4 from './pdfFinal.png';
import pdf_one from './pptout/pdf_one.jpg';
import pdf_two from './pptout/pdf_two.jpg';
import excel_one from './pptout/excel_one.jpg';
import excel_two from './pptout/excel_two.jpg';
import ppt_one from './pptout/ppt_one.jpg';
import ppt_two from './pptout/ppt_two.jpg';
import ppt_three from './pptout/ppt_three.jpg';
import ppt_four from './pptout/ppt_four.jpg';
import ppt_six from './pptout/ppt_six.png';
import ppt_seven from './pptout/ppt_seven.jpg';
import ppt_eight from './pptout/ppt_eight.jpg';
import ppt_nine from './pptout/ppt_nine.jpg';
import ppt_ten from './pptout/ppt_six.png';
import ppt_eleven from './templates/m3.jpg';
import ppt_twelve from './templates/s12.jpg';
import ppt_therteen from './templates/s13.jpg';
import ppt_forrteen from './pptout/14.jpg';
import ppt_fifteen from './pptout/15.jpg';
import ppt_sixteen from './pptout/16.jpg';
import ppt_seventeen from './pptout/17.jpg';
import excel from './formatsPage/Excel2.jpg';
import fontImages from './formatsPage/MetalExport.png';
import EmailIcon from '@rsuite/icons/Email';
import garment1 from './formatsPage/garment1.jpg';
import CopyToClipboard from 'react-copy-to-clipboard';
import globalIP from '../../GlobelIP';
import { Player } from '@lottiefiles/react-lottie-player';
import animati from './animation/Cuttie.json';
import QRCode from 'qrcode.react';
import Port from '@/Port';
import {
  downloadExcelData,
  downloadExcelData2
} from '@/components/ExcelFormates/DownloadExcelFormates';
import {
  handleDownloadPDF,
  handleDownloadPDF2
} from '@/components/PdfFormates/DownloadPdfFormates';
import {
  handleDownloadPPT1,
  handleDownloadPPT2,
  handleDownloadPPT3,
  handleDownloadPPT4,
  handleDownloadPPT5,
  handleDownloadPPT6,
  handleDownloadPPT7,
  handleDownloadPPT8,
  handleDownloadPPT9,
  handleDownloadPPT11,
  handleDownloadPPT12,
  handleDownloadPPT13,
  handleDownloadPPT14,
  handleDownloadPPT15,
  handleDownloadPPT16,
  handleDownloadPPT17,
  handleDownloadPPT18,
  handleDownloadPPT19,
  handleDownloadPPT20
} from '@/components/PptFormates/DownloadPptFormates';
import {
  Button,
  Form,
  Stack,
  Breadcrumb,
  Divider,
  ButtonGroup,
  Panel,
  Container,
  Modal,
  Input,
  FlexboxGrid,
  Message,
  Col,
  Drawer,
  DateRangePicker,
  useToaster,
  Checkbox,
  Loader,
  IconButton,
  Notification,
  SelectPicker,
  Whisper
} from 'rsuite';
import { Link, useLocation } from 'react-router-dom';
import 'jspdf-autotable';
import GenerateAuthSlider from './GenerateAuthSlider';
import ugr from '@/UGRoute';
import FormControlLabel from 'rsuite/esm/FormControlLabel';
import Textarea from '@/components/Textarea';
import GenerateQrSlider from './GenerateQrSlider';
import { fetchColors, fetchFinishes, fetchProductLabel } from '@/apiService/apiService';
import useUser from '../../components/UseUser';
import axios from 'axios';
declare module 'jspdf' {
  interface jsPDF {
    autoTable: (options: object) => jsPDF;
  }
}
const Generate = () => {
  const { user } = useUser();
  const ip = globalIP;
  const [cata, setCata] = useState([]);
  const [cataName, setCataName] = useState('');
  const [cataCode, setCataCode] = useState('');
  const [buyername, setBuyerName] = useState('');
  const [buyerDetail, setBuyerDetail] = useState(null);
  const [cataloguecatappt, setCataloguecatappt] = useState([]);
  const [catalogueCatProductSize, setCatalogueCatProductSize] = useState([]);
  const [cataloguebyid, setCatalogueByid] = useState([]);
  const [openGenerateSlider, setOpenGenerateSlider] = useState(false);
  const [linkGenrate, setLinkGenrate] = useState();
  const location = useLocation();
  const [openn, setOpenn] = useState(false);
  const [sizee, setSizee] = useState();
  const filterStatus = '';
  const [colordata, setColordata] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoadingcolor, setIsLoadingcolor] = useState(false);
  const [openWithHeader, setOpenWithHeader] = useState(false);

  useEffect(() => {
    fetchColors(setColordata, isLoadingcolor, setIsLoadingcolor, filterStatus);
  }, []);

  const handleOpenn = (value: string) => {
    setSizee(value);
    setOpenn(true);

    // Auto-fill buyer email from catalogue data
    const buyerEmailFromCatalogue = cataloguedata[0]?.attributes?.BuyerEmail || '';
    const capitalizeName = (name: string) => {
      return name
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    };

    const senderName = capitalizeName(cataloguedata[0]?.attributes?.CreateBy || '');
    const cmpName = data2[0]?.attributes?.cmpnm || '';
    setTo(buyerEmailFromCatalogue);
    // Set subject with catalogue name
    setSubject(`Catalogue Access Link`);
    setMessage(
      `Hello ${cataloguedata[0]?.attributes?.BuyerName || ''},\n\n` +
        `Greetings from ${cmpName}.\n\n` +
        `As discussed, please find below the catalogue access link for your reference:\n\n` +
        `👉 Catalogue Link:\n` +
        `${linkGenrate ? `${data2[0]?.attributes.GLink}${linkGenrate}` : ''}\n\n` +
        `If you face any difficulty while accessing the link, please feel free to reach out to us. We will be happy to assist you.\n\n` +
        `Looking forward to your feedback.\n\n` +
        `Warm regards,\n` +
        `${senderName}\n` +
        `${cmpName}`
    );
    // Convert last downloaded blob to attachment if exists
    if (lastDownloadedBlob && lastDownloadedFileName) {
      convertBlobToAttachment(lastDownloadedBlob, lastDownloadedFileName);
    }
  };

  const convertBlobToAttachment = (blob: Blob, fileName: string) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result?.toString().split(',')[1] || '';
      setAttachment({
        filename: fileName,
        contentType: blob.type,
        content: base64
      });
    };
    reader.readAsDataURL(blob);
  };
  const handleClose = () => {
    setOpenn(false);
    setTo('');
    setSubject('');
    setMessage('');
    setAttachment({ filename: null, contentType: null, content: null });
  };

  // const sendemail = async () => {
  //   // const endpoint = `${ipp}/api/email`;
  //      const endpoint = `${ip}/api/send-mail`;
  //   const data = {
  //     toEmail: to,
  //     subject: subject,
  //     message: message,
  //     attachments: [
  //       {
  //         filename: attachment.filename || '', // Use empty string if filename is null
  //         contentType: attachment.content || '', // Use empty string if content is null
  //         base64: 'base64'
  //       }
  //     ]
  //   };
  //   try {
  //     setLoading(true);
  //     const response = await fetch(endpoint, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json'
  //       },
  //       body: JSON.stringify(data)
  //     });
  //     if (response.ok) {
  //       setLoading(false);
  //       handleClose();
  //       toaster.push(
  //         <Message showIcon type="success">
  //           Email sent successfully!
  //         </Message>,
  //         { placement: 'topEnd' }
  //       );
  //     } else {
  //       console.error('Failed to send email');
  //       toaster.push(
  //         <Message showIcon type="error">
  //           Failed to send email
  //         </Message>,
  //         { placement: 'topEnd' }
  //       );
  //     }
  //   } catch (error) {
  //     console.error('Error:', error);
  //   }
  // };
  const sendemail = async () => {
    const endpoint = `${ip}/api/send-mail`;

    // Validation
    if (!to || !subject) {
      toaster.push(
        <Message showIcon type="warning">
          Please fill recipient email and subject
        </Message>,
        { placement: 'topEnd' }
      );
      return;
    }

    // Prepare attachments array (empty if no attachment)
    const attachments = [];
    if (attachment.filename && attachment.content) {
      attachments.push({
        filename: attachment.filename,
        contentType: attachment.contentType || 'application/octet-stream',
        base64: attachment.content
      });
    }

    const data = {
      toEmail: to,
      subject: subject,
      message: message,
      attachments: attachments // Can be empty array
    };

    try {
      setLoading(true);
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (response.ok) {
        setLoading(false);
        handleClose();
        toaster.push(
          <Message showIcon type="success">
            Email sent successfully!
          </Message>,
          { placement: 'topEnd' }
        );
      } else {
        const errorData = await response.json();
        console.error('Failed to send email:', errorData);
        setLoading(false);
        toaster.push(
          <Message showIcon type="error">
            Failed to send email: {errorData.message || 'Unknown error'}
          </Message>,
          { placement: 'topEnd' }
        );
      }
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      toaster.push(
        <Message showIcon type="error">
          Error sending email. Please try again.
        </Message>,
        { placement: 'topEnd' }
      );
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const catalogueName = queryParams.get('cataloguename');
    const catalogueCode = queryParams.get('cataloguecode');
    setCataName(catalogueName);
    setCataCode(catalogueCode);
  }, [location.search]);

  const [cataloguedata, setCatalogueData] = useState([]);
  useEffect(() => {
    if (cataCode) {
      fetchDatacatadata();
    }
  }, [cataCode]);

  const fetchDatacatadata = async () => {
    const response = await fetch(
      `${ip}/api/catalogues?populate=*&filters[CatalogueCode][$eq]=${cataCode}`
    );
    const json = await response.json();
    setCatalogueData(json.data);
    setCataloguecatappt(json.data.flatMap(catalogue => catalogue.attributes.CatalogueProduct));
    // const catalogProducts = json.data.flatMap(catalogue =>
    //   catalogue.attributes.CatalogueProduct.map(product => product.CatalogProduct)
    // );
    const catalogProducts = json.data.flatMap(catalogue =>
      catalogue.attributes.CatalogueProduct.map(product => ({
        id: parseInt(product.CatalogProduct, 10),
        productId: product.aliascd
      }))
    );
    setCatalogueCatProductSize(
      json.data
        .flatMap(catalogue => catalogue.attributes.ProductSizes)
        .filter(item => item.status != false)
    );

    const buyerName = json.data[0]?.attributes?.BuyerName;
    setBuyerName(buyerName);
    if (buyerName) {
      fetchBuyerDetails(buyerName);
    }

    setLinkGenrate(json.data[0]?.attributes.Glink);
    if (json.data[0]?.attributes.Glink) {
      setShowCopyButton(true);
    }
  };
  const fetchBuyerDetails = async buyerName => {
    if (!buyerName) return;

    try {
      const response = await fetch(
        `${ip}/api/buyer-details?filters[buyernm][$eq]=${encodeURIComponent(buyerName)}&populate=*`
      );
      const json = await response.json();
      if (json?.data?.length) {
        const buyer = json.data[0].attributes;
        // setBuyerCode(buyer.BuyerCode);
        setBuyerDetail(buyer); // optional: store full object
      }
    } catch (err) {
      console.error('Error fetching buyer details', err);
    }
  };

  const searchParams = new URLSearchParams(location.search);

  const selectedItems = searchParams.get('id');
  const catlename = searchParams.get('cataloguename');
  const catalogueCode = searchParams.get('cataloguecode');

  const bulkIds = searchParams.get('bulkid'); // "527,525,524" | null

  const catalogueIds = bulkIds ? bulkIds.split(',').filter(Boolean) : [];

  const [data2, setData2] = useState([]);
  const [companytype, setCompanytype] = useState('');
  useEffect(() => {
    fetchcatappt();
  }, []);
  const fetchcatappt = async () => {
    const response = await fetch(`${ip}/api/company-details?populate=*`);
    const json = await response.json();
    setData2(json.data);
    setCompanytype(json.data[0]?.attributes.Type);
  };
  const longUrl =
    'http://192.168.1.27:3000/UniqGrow/client/apptwo?Key=OQqdB7GXHi5bYytU9YOQV1YpKPZa8lNpQ8XxM5P7f0PK5Kkhcb&id=Mzk=&Cat_id=NDk5';
  const [shortUrl, setShortUrl] = useState('');
  useEffect(() => {
    handleShorten();
  }, [linkGenrate]);
  const handleShorten = async () => {
    setShortUrl('');
    try {
      const response = await axios.get(
        `https://tinyurl.com/api-create.php?url=${encodeURIComponent(longUrl)}`
      );
      setShortUrl(response.data);
    } catch (err) {
      console.error('Error generating short link:', err);
      setShortUrl('Error generating link');
    }
  };
  useEffect(() => {
    fetchDatabyid();
    setCataName(catlename);
  }, []);

  const fetchDatabyid = async () => {
    const url = selectedItems
      ? `${ip}/api/catalogues?populate=*&filters[id][$eq]=${selectedItems}`
      : `${ip}/api/catalogues?populate=*&filters[CatalogueCode][$eq]=${catalogueCode}`;
    const response = await fetch(url);
    const json = await response.json();
    setCataloguecatappt(json.data.flatMap(catalogue => catalogue.attributes.CatalogueProduct));
    setCatalogueCatProductSize(
      json.data
        .flatMap(catalogue => catalogue.attributes.ProductSizes)
        .filter(item => item.status != false)
    );
    // const catalogProducts = json.data.flatMap(catalogue =>
    //   catalogue.attributes.CatalogueProduct.map(product => product.CatalogProduct)
    // );
    const catalogProducts = json.data.flatMap(catalogue =>
      catalogue.attributes.CatalogueProduct.map(product => ({
        id: parseInt(product.CatalogProduct, 10),
        productId: product.aliascd
      }))
    );
    setLinkGenrate(json.data[0]?.attributes.Glink);
    if (json.data[0]?.attributes.Glink) {
      setShowCopyButton(true);
    }
    setCatalogueByid(catalogProducts);
    setBuyerName(json.data[0]?.attributes.BuyerName);
  };
  useEffect(() => {
    if (cataloguebyid) {
      fetchProducts();
    }
  }, [cataloguebyid]);

  //   const fetchDatabyid = async () => {
  //   if (!catalogueIds.length) return;

  //   const idFilter = catalogueIds.map(id => `filters[id][$in]=${id}`).join('&');
  //   const response = await fetch(`${ip}/api/catalogues?populate=*&${idFilter}`);
  //   const json = await response.json();

  //   const catalogueMeta = json.data.map(c => ({
  //     id: c.id,
  //     catalogueName: c.attributes.CatalogueName,
  //     products: c.attributes.CatalogueProduct.map(p => ({
  //       id: parseInt(p.CatalogProduct, 10),
  //       productId: p.aliascd
  //     }))
  //   }));

  //   setCataloguecatappt(json.data.flatMap(c => c.attributes.CatalogueProduct));
  //   // setCatalogueCatProductSize(allProductSizes);
  //   setCatalogueByid(catalogueMeta);

  //   // setShowCopyButton(allLinks.length > 0);
  //   // setLinkGenrate(allLinks[0]); // pick the first if multiple
  //   // setBuyerName(allBuyers.join(', '));
  // };

  //   const fetchProductsForAll = async () => {
  //   const finalData = [];

  //   for (const catalogue of cataloguebyid) {
  //     const { id, catalogueName, products } = catalogue;

  //     const idQuery = products.map(p => `filters[id][$in][]=${p.id}`).join('&');
  //     const aliasQuery = products
  //       .filter(p => p.productId)
  //       .map(p => `filters[ProductId][$in][]=${encodeURIComponent(p.productId)}`)
  //       .join('&');
  //     const combinedFilter = [idQuery, aliasQuery].filter(Boolean).join('&');

  //     const productResponse = await fetch(`${ip}/api/products?${combinedFilter}&populate=*`);
  //     const productJson = await productResponse.json();

  //     const variantResponse = await fetch(`${ip}/api/variant-products?${combinedFilter}&populate=*`);
  //     const variantJson = await variantResponse.json();

  //     const mergedProducts = [...productJson.data, ...variantJson.data];

  //     finalData.push({
  //       id,
  //       catalogueName,
  //       product: mergedProducts
  //     });
  //   }

  //   setCata(finalData); // Final structured cata
  // };

  // const fetchProducts = async () => {

  //   try {
  //     const productIdsQueryParam = cataloguebyid.map(p => `filters[id][$in][]=${p.id}`).join('&');
  //     const productIdFilters = cataloguebyid
  //       .filter(p => p.productId) // ignore undefined aliascd
  //       .map(p => `filters[ProductId][$in][]=${encodeURIComponent(p.productId)}`)
  //       .join('&');

  //     const filterQuery = [productIdsQueryParam, productIdFilters].filter(Boolean).join('&');
  //     const apiUrl = `${ip}/api/products?${filterQuery}&populate=*&pagination[page]=1`;
  //     const response = await fetch(apiUrl);
  //     const json = await response.json();

  //     const allData = [];
  //     if (filterQuery) {
  //       for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
  //         const pageResponse = await fetch(
  //           `${ip}/api/products?${filterQuery}&populate=*&pagination[page]=${page}`
  //         );
  //         const pageJson = await pageResponse.json();
  //         allData.push(...pageJson.data);
  //       }
  //     }

  //     // const productvarid = cataloguebyid.map(id => `filters[id][$eq]=${id}`).join('&');
  //     const responsevar = await fetch(`${ip}/api/variant-products?${filterQuery}&populate=*`);
  //     const jsonvar = await responsevar.json();
  //     const catadata = [...allData, ...jsonvar.data];
  //     if (selectedItems || cataName) {
  //       setCata(
  //         catadata.sort((a, b) => {
  //           // Sort by id in ascending order
  //           return b.id - a.id; // Change to b.id - a.id for descending order
  //         })
  //       );
  //     }
  //   } catch (error) {
  //     console.error('Error fetching products:', error);
  //   }
  // };
  const fetchProducts = async () => {
    try {
      const batchSize = 100; // 🔥 important
      const allData = [];

      // Split catalogue into batches
      for (let i = 0; i < cataloguebyid.length; i += batchSize) {
        const batch = cataloguebyid.slice(i, i + batchSize);

        const productIdsQueryParam = batch.map(p => `filters[id][$in][]=${p.id}`).join('&');

        const productIdFilters = batch
          .filter(p => p.productId)
          .map(p => `filters[ProductId][$in][]=${encodeURIComponent(p.productId)}`)
          .join('&');

        const filterQuery = [productIdsQueryParam, productIdFilters].filter(Boolean).join('&');

        if (!filterQuery) continue;

        const apiUrl = `${ip}/api/products?${filterQuery}&populate=*&pagination[page]=1`;

        const response = await fetch(apiUrl);
        const json = await response.json();

        for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
          const pageResponse = await fetch(
            `${ip}/api/products?${filterQuery}&populate=*&pagination[page]=${page}`
          );
          const pageJson = await pageResponse.json();
          allData.push(...pageJson.data);
        }
      }

      // 🔥 Variant products also batched
      const variantData = [];

      for (let i = 0; i < cataloguebyid.length; i += batchSize) {
        const batch = cataloguebyid.slice(i, i + batchSize);

        const variantQuery = batch.map(p => `filters[id][$in][]=${p.id}`).join('&');

        if (!variantQuery) continue;

        const responsevar = await fetch(`${ip}/api/variant-products?${variantQuery}&populate=*`);

        const jsonvar = await responsevar.json();
        variantData.push(...jsonvar.data);
      }

      const catadata = [...allData, ...variantData];

      if (selectedItems || cataName) {
        setCata(catadata.sort((a, b) => b.id - a.id));
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const searchParamsQ = new URLSearchParams(location.search);
  const selectedItemsQ = searchParamsQ.get('idq') || '';
  const catlenameQ = searchParamsQ.get('Qname') || '';
  const [cataloguebyidQ, setCatalogueByidQ] = useState([]);

  useEffect(() => {
    if (selectedItemsQ) {
      fetchDatabyidQ();
      setCataName(catlenameQ);
    }
  }, [selectedItemsQ]);
  const fetchDatabyidQ = async () => {
    const response = await fetch(
      `${ip}/api/quotations?populate=*&filters[id][$eq]=${selectedItemsQ}`
    );
    const json = await response.json();
    const catalogProductsQ = json.data.flatMap(catalogue =>
      catalogue.attributes.QuotationProduct.map(product => product.QuotationProductcode)
    );
    setCatalogueByidQ(catalogProductsQ);
  };
  useEffect(() => {
    if (cataloguebyidQ) {
      fetchProductsQ();
    }
  }, [cataloguebyidQ]);
  const fetchProductsQ = async () => {
    try {
      const productIdsQueryParam = cataloguebyidQ
        .map(id => `filters[ProductId][$in][]=${id}`)
        .join('&');
      const apiUrl = `${ip}/api/products?${productIdsQueryParam}&populate=*`;
      const response = await fetch(apiUrl);
      const json = await response.json();
      // Set the fetched products
      if (selectedItemsQ) {
        setCata(
          json.data.sort((a, b) => {
            // Sort by id in ascending order
            return b.id - a.id; // Change to b.id - a.id for descending order
          })
        );
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const [watermarkUrl, setWatermarkUrl] = useState<string | null>(null);
  const [watermark, setWatermark] = useState(false);
  const [watermarkAccess, setWatermarkAccess] = useState(false);
  const fetchDataWaterMrk1 = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details?populate=*`);
      const json = await response.json();
      // Fetch watermark image URL
      const watermarkUrl = `${ip}${json.data[0]?.attributes?.WaterMark?.data?.attributes?.url}`;
      const watermark12 = json.data[0]?.attributes?.Wcataloue;
      setWatermarkUrl(watermarkUrl);
      // setWatermark(watermark12)
      setWatermarkAccess(watermark12);
    } catch (error) {
      console.error('Error fetching company data:', error);
    }
  };

  useEffect(() => {
    fetchDataWaterMrk1();
  }, []);
  // Function to merge watermark over cover image
  const mergeImagesWithWatermark = async (imageUrl, watermarkUrl) => {
    // Load the main image with cross-origin
    const originalImage = new Image();
    originalImage.crossOrigin = 'anonymous'; // Set CORS for the main image
    originalImage.src = imageUrl;
    await new Promise(resolve => {
      originalImage.onload = resolve;
    });
    // Load the watermark image with cross-origin
    const watermarkImage = new Image();
    watermarkImage.crossOrigin = 'anonymous'; // Set CORS for the watermark image
    watermarkImage.src = watermarkUrl;
    await new Promise(resolve => {
      watermarkImage.onload = resolve;
    });
    // Create a canvas to draw both images
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    // Set canvas size to match the original image
    canvas.width = originalImage.width;
    canvas.height = originalImage.height;
    // Draw the original image on the canvas
    ctx.drawImage(originalImage, 0, 0);
    // Set watermark opacity (optional)
    ctx.globalAlpha = 1; // Adjust this for transparency
    // Draw the watermark image
    ctx.drawImage(watermarkImage, 0, 0, originalImage.width, originalImage.height);
    // Convert the canvas to a base64 string
    const mergedImageBase64 = canvas.toDataURL('image/jpeg'); // Can be png or jpg depending on the format you want
    return mergedImageBase64;
  };

  const csvData = cata.map(item => {
    const { id, attributes } = item;
    const {
      MaterialCollection,
      ProductionDetail,
      MultipleImage,
      CoverImage,
      Packaging,
      FortyHQ,
      FortyFT,
      TwentyFT,
      Total_CBM,
      publishedAt,
      updatedAt,
      createdAt,
      BuyerSku,
      BuyerName,
      ColorName,
      cbm,
      ProductTypeCode,
      MadeBy,
      ProductDesigner,
      MOQ,
      SearchKeyword,
      ProductCost,
      HSNCode,
      ColorCode,
      FinishCode,
      ProductCode,
      CategoryCode,
      Total_CFT,
      ...restAttributes
    } = attributes;
    const imageUrl = `${ip}${attributes.CoverImage?.data?.attributes?.url || ''}`;
    return {
      id,
      Image: imageUrl,
      ...restAttributes
    };
  });

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchProductLabel(setLabel);
  }, []);

  const [opencheck, setOpenCheck] = useState(false);
  const handleOpencheck = () => setOpenCheck(true);
  const handleClosecheck = () => {
    checkexcel();
    checkpdf();
    check();
    setOpenCheck(false);
    if (cataCode) {
      fetchDatacatadata();
    }
  };
  ////// For PPT //////
  const [catappt, setCataPpt] = useState([]);
  const [waterMrk, setWaterMrk] = useState([]);
  const [slides, setSlides] = useState([]);
  const [buyercata, setBuyercata] = useState([]);
  const [buyercataslide, setBuyercataSlide] = useState([]);
  const [lastDownloadedBlob, setLastDownloadedBlob] = useState<Blob | null>(null);
  const [lastDownloadedFileName, setLastDownloadedFileName] = useState<string>('');
  const [templib, setTempLib] = useState([]);
  const check = () => {
    const checkbuyer = templib.some(item => item == buyerDetail?.buyercode);
    console.log(checkbuyer, templib, buyerDetail);
    if (checkbuyer) {
      if (buyerDetail) {
        fetchDatabybuyer();
      } else {
        fetchData();
      }
    } else {
      fetchData();
    }
    fetchData();
  };
  const fetchData = async () => {
    const response = await fetch(`${ip}/api/temp-libs?populate=*&filters[Type][$eq]=Regular`);
    const json = await response.json();
    setCataPpt(json.data);
    const slides = json.data[0]?.attributes?.Slides;
    setSlides(slides);
  };
  const fetchDatabybuyer = async () => {
    const response = await fetch(
      `${ip}/api/temp-libs?populate=*&filters[Type][$eq]=Buyer&filters[BuyerName][$eq]=${buyerDetail?.buyercode}`
    );
    const json = await response.json();
    setBuyercata(json.data);
    setBuyercataSlide(json.data[0]?.attributes.Slides);
  };
  useEffect(() => {
    // Call handleOpencheck after 1 second
    const timer = setTimeout(() => {
      fetchDataAll();
      handleOpencheck();
    }, 1000);

    // Cleanup timeout if component unmounts before 1s
    return () => clearTimeout(timer);
  }, []);

  const fetchDataAll = async () => {
    const response = await fetch(`${ip}/api/temp-libs?populate=*`);
    const json = await response.json();
    setTempLib(json.data.map(item => item.attributes.BuyerName));
  };
  useEffect(() => {
    fetchDataWaterMrk();
  }, []);

  const fetchDataWaterMrk = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details`);
      const json = await response.json();
      const extractedData = json.data[0].attributes;
      if (extractedData.Wcataloue && extractedData.WaterMark?.data) {
        const watermarkUrl = `${ip}${extractedData.WaterMark.data.attributes.url}`;
        setWaterMrk(watermarkUrl);
      }
    } catch (error) {
      console.error('Error fetching watermark data:', error);
    }
  };
  ////// For PPT //////

  ////// For PDF //////
  const [catapdf, setCataPdf] = useState([]);
  const [slidespdf, setSlidespdf] = useState([]);
  const [buyercatapdf, setBuyercatapdf] = useState([]);
  const [buyercataslidepdf, setBuyercataSlidepdf] = useState([]);
  const [templibpdf, setTempLibpdf] = useState([]);
  const checkpdf = () => {
    const checkbuyer = templibpdf.some(item => item == buyername);
    if (checkbuyer) {
      if (buyername) {
        fetchDatabybuyerpdf();
      } else {
        fetchDatapdf();
      }
    } else {
      fetchDatapdf();
    }
  };
  const fetchDatapdf = async () => {
    const response = await fetch(`${ip}/api/temp-lib-ppts?populate=*&filters[Type][$eq]=Regular`);
    const json = await response.json();
    setCataPdf(json.data);
    const slides = json.data[0]?.attributes?.Pages;
    setSlidespdf(slides);
  };
  const fetchDatabybuyerpdf = async () => {
    const response = await fetch(
      `${ip}/api/temp-lib-ppts?populate=*&filters[Type][$eq]=Buyer&filters[BuyerName][$eq]=${buyername}`
    );
    const json = await response.json();
    setBuyercatapdf(json.data);
    setBuyercataSlidepdf(json.data[0]?.attributes.Pages);
  };
  useEffect(() => {
    fetchDataAllpdf();
  }, []);
  const fetchDataAllpdf = async () => {
    const response = await fetch(`${ip}/api/temp-lib-ppts?populate=*`);
    const json = await response.json();
    setTempLibpdf(json.data.map(item => item.attributes.BuyerName));
  };
  ////// For PDF //////

  ////// For Ecxcel //////
  const [cataexcel, setCataexcel] = useState([]);
  const [slidesexcel, setSlidesexcel] = useState([]);
  const [buyercataexcel, setBuyercataexcel] = useState([]);
  const [buyercataslideexcel, setBuyercataSlideexcel] = useState([]);
  const [templibexcel, setTempLibexcel] = useState([]);

  const checkexcel = () => {
    const checkbuyer = templibexcel.some(item => item == buyername);
    if (checkbuyer) {
      if (buyername) {
        fetchDatabybuyerexcel();
      } else {
        fetchDataexcel();
      }
    } else {
      fetchDataexcel();
    }
  };
  const fetchDataexcel = async () => {
    const response = await fetch(`${ip}/api/temp-lib-excels?populate=*&filters[Type][$eq]=Regular`);
    const json = await response.json();
    setCataexcel(json.data);
    const slides = json.data[0]?.attributes?.Body;
    setSlidesexcel(slides);
  };
  const fetchDatabybuyerexcel = async () => {
    const response = await fetch(
      `${ip}/api/temp-lib-excels?populate=*&filters[Type][$eq]=Buyer&filters[BuyerName][$eq]=${buyername}`
    );
    const json = await response.json();
    setBuyercataexcel(json.data);
    setBuyercataSlideexcel(json.data[0]?.attributes.Body);
  };
  useEffect(() => {
    fetchDataAllexcel();
  }, []);
  const fetchDataAllexcel = async () => {
    const response = await fetch(`${ip}/api/temp-lib-excels?populate=*`);
    const json = await response.json();
    setTempLibexcel(json.data.map(item => item.attributes.BuyerName));
  };
  useEffect(() => {
    fetchDatacurr();
  }, []);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const fetchDatacurr = async () => {
    try {
      const response = await fetch(`${ip}/api/currency-masters`);
      const json = await response.json();

      const currency = json.data.map(item => ({
        label: item.attributes.currencyname, // Setting label
        value: item.attributes.currencyname, // Setting value
        exchangerate: item.attributes.exchangerate
      }));
      setCurrencyOptions(currency);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [selectedUnit, setSelectedUnit] = useState('cm');
  const unitOptions = [
    { label: 'Centimeter (cm)', value: 'cm' },
    { label: 'Inches (in)', value: 'inch' }
  ];

  const [selectedCurrency, setSelectedCurrency] = useState('USD');
  // Get selected currency object from dynamic API data
  const selectedCurrencyObj = currencyOptions.find(c => c.value === selectedCurrency);

  // Default to INR if nothing selected
  const selectedRate = selectedCurrencyObj ? Number(selectedCurrencyObj.exchangerate) : 1;
  ////// For Ecxcel //////
  const [openattri, setOpenAttri] = useState(false);
  const [openattri1, setOpenAttri1] = useState(false);
  const [loadppt, setLoadPPT] = useState(false);
  const [selectedButton, setSelectedButton] = useState(null);
  const [maxAttributes, setMaxAttributes] = useState(15);
  const pptAttributeLimit = {
    button1: 11, // Format F1
    button2: 13, // Format F2
    button3: 15, // Format F4
    button4: 11, // Format F6
    button15: 15 // Format F17
  };

  const handleOpenAttributes = buttonKey => {
    const limit = pptAttributeLimit[buttonKey] || 15; // default max attributes
    setMaxAttributes(limit);
    setSelectedButton(buttonKey);
    setOpenAttri(true);
  };
  const [selectedAttrs, setSelectedAttrs] = useState({
    productName: false,
    productAlias: false,
    productsizerange: false,
    productsize: false,
    productfinish: false,
    productntw: false,
    productcbm: false,
    productInnerAndMaster: false,
    productMaterialName: false,
    productMoq: false,
    productcategory: false,
    producttype: false,
    productdesc: false,
    productsalepri: false,
    productcurrency: false,
    productremark: false,
    ptech: false,
    madeby: false
    // sizeshow: false,
  });

  // Count selected
  const selectedCount = Object.values(selectedAttrs).filter(Boolean).length;

  // Toggle function
  const toggleAttr = key => {
    // If currently unchecked AND max reached, do nothing
    if (!selectedAttrs[key] && selectedCount >= maxAttributes) return;

    // Otherwise toggle
    setSelectedAttrs(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const getSelectedAttributes = () => {
    const attrs = [];
    Object.keys(selectedAttrs).forEach(key => {
      if (selectedAttrs[key]) {
        attrs.push(key);
      }
    });
    return attrs;
  };

  const handleCloseandsave = value => {
    if (selectedCount > maxAttributes) {
      toaster.push(
        <Notification type="warning" header="Limit Exceeded" closable>
          You can only select up to {maxAttributes} attributes.
        </Notification>,
        { placement: 'topEnd' }
      );
      return;
    }
    if (slides.length <= 1) {
      if (value == 'Format F1') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT1(
          cata,
          buyername,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm
        );
      } else if (value == 'Format F2') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT2(
          cata,
          buyername,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm,
          // ptech,
          // madeby
        );
      } else if (value == 'Format F3') {
        handleDownloadPPT4();
      } else if (value == 'Format F4') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT3(
          cata,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          catalogueCatProductSize,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm,
          // productMaterialName,
          // productInnerAndMaster,
          // productMoq,
          // ptech,
          // madeby
        );
      } else if (value == 'Format F5') {
        handleDownloadPPT5(
          data2,
          cata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          cataName,
          selectedUnit,
          selectedCurrency,
          selectedRate
        );
      } else if (value == 'Format F6') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT6(
          cata,
          buyername,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm
        );
      } else if (value == 'Format F7') {
        handleDownloadPPT11();
      } else if (value == 'Format F8') {
        handleDownloadPPT11();
      } else if (value == 'Format F12') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT15(
          cata,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          catalogueCatProductSize,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm,
          // productMaterialName,
          // productInnerAndMaster,
          // productMoq,
          // ptech,
          // madeby
        );
      } else if (value == 'Format F14') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT17(
          cata,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          catalogueCatProductSize,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm,
          // productMaterialName,
          // productInnerAndMaster,
          // productMoq,
          // ptech,
          // madeby
        );
      } else if (value == 'Format F17') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT20(
          cata,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          catalogueCatProductSize,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm,
          // productMaterialName,
          // productInnerAndMaster,
          // productMoq,
          // ptech,
          // madeby
        );
      } else {
        toaster.push(
          <Message showIcon type="error">
            Something went Wrong!
          </Message>,
          { placement: 'topCenter' }
        );
      }
    } else {
      if (selectedButton === 'button1') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT1(
          cata,
          buyername,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          setOpen,
          cataName,
          cataloguecatappt,
          label,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm
        );
      } else if (selectedButton === 'button2') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT2(
          cata,
          buyername,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          setOpen,
          cataName,
          cataloguecatappt,
          label,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm,
          // ptech,
          // madeby
        );
      } else if (selectedButton === 'button3') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT3(
          cata,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          setOpen,
          cataName,
          cataloguecatappt,
          label,
          catalogueCatProductSize,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm,
          // productMaterialName,
          // productInnerAndMaster,
          // productMoq,
          // ptech,
          // madeby
        );
      } else if (selectedButton === 'button4') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT6(
          cata,
          buyername,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          setOpen,
          cataName,
          cataloguecatappt,
          label,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm
        );
      } else if (selectedButton === 'button5') {
        handleDownloadPDF(
          cata,
          cataloguecatappt,
          label,
          data2,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          cataName,
          selectedUnit,
          selectedCurrency,
          selectedRate
        );
      } else if (selectedButton === 'button6') {
        handleDownloadPDF2(
          cata,
          cataloguecatappt,
          label,
          data2,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          cataName,
          catapdf,
          buyercatapdf,
          buyername,
          selectedUnit,
          selectedCurrency,
          selectedRate
        );
      } else if (selectedButton === 'button7') {
        handleDownloadPPT11();
      } else if (selectedButton === 'button8') {
        handleDownloadPPT11();
      } else if (selectedButton == 'button12') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT15(
          cata,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          setOpen,
          cataName,
          cataloguecatappt,
          label,
          catalogueCatProductSize,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm,
          // productMaterialName,
          // productInnerAndMaster,
          // productMoq,
          // ptech,
          // madeby
        );
      } else if (selectedButton == 'button14') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT17(
          cata,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          setOpen,
          cataName,
          cataloguecatappt,
          label,
          catalogueCatProductSize,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm,
          // productMaterialName,
          // productInnerAndMaster,
          // productMoq,
          // ptech,
          // madeby
        );
      } else if (selectedButton == 'button15') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT20(
          cata,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          setOpen,
          cataName,
          cataloguecatappt,
          label,
          catalogueCatProductSize,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm,
          // productMaterialName,
          // productInnerAndMaster,
          // productMoq,
          // ptech,
          // madeby
        );
      }
      setSelectedButton(null);
    }
  };
  const handleCloseandsaveb = value => {
    if (buyercataslide.length <= 1) {
      if (value == 'Format F1') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT1(
          cata,
          buyername,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm
        );
      } else if (value == 'Format F2') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT2(
          cata,
          buyername,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm,
          // ptech,
          // madeby
        );
      } else if (value == 'Format F3') {
        handleDownloadPPT4();
      } else if (value == 'Format F4') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT3(
          cata,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          catalogueCatProductSize,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm,
          // productMaterialName,
          // productInnerAndMaster,
          // productMoq,
          // ptech,
          // madeby
        );
      } else if (value == 'Format F5') {
        handleDownloadPPT5(
          data2,
          cata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          cataName,
          selectedUnit,
          selectedCurrency,
          selectedRate
        );
      } else if (value == 'Format F6') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT6(
          cata,
          buyername,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm
        );
      } else if (value == 'Format F7') {
        handleDownloadPPT11();
      } else if (value == 'Format F8') {
        handleDownloadPPT11();
      } else if (value == 'Format F12') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT15(
          cata,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          catalogueCatProductSize,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm,
          // productMaterialName,
          // productInnerAndMaster,
          // productMoq,
          // ptech,
          // madeby
        );
      } else if (value == 'Format F14') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT17(
          cata,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          catalogueCatProductSize,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm,
          // productMaterialName,
          // productInnerAndMaster,
          // productMoq,
          // ptech,
          // madeby
        );
      } else if (value == 'Format F17') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT20(
          cata,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          catalogueCatProductSize,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm,
          // productMaterialName,
          // productInnerAndMaster,
          // productMoq,
          // ptech,
          // madeby
        );
      } else {
        toaster.push(
          <Message showIcon type="error">
            Something went Wrong!
          </Message>,
          { placement: 'topCenter' }
        );
      }
    } else {
      if (selectedButton === 'button1') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT1(
          cata,
          buyername,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm
        );
      } else if (selectedButton === 'button2') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT2(
          cata,
          buyername,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm,
          // ptech,
          // madeby
        );
      } else if (selectedButton === 'button3') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT3(
          cata,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          catalogueCatProductSize,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm,
          // productMaterialName,
          // productInnerAndMaster,
          // productMoq,
          // ptech,
          // madeby
        );
      } else if (selectedButton === 'button4') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT6(
          cata,
          buyername,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm
        );
      } else if (selectedButton === 'button5') {
        handleDownloadPDF(
          cata,
          cataloguecatappt,
          label,
          data2,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          cataName,
          selectedUnit,
          selectedCurrency,
          selectedRate
        );
      } else if (selectedButton === 'button6') {
        handleDownloadPDF2(
          cata,
          cataloguecatappt,
          label,
          data2,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          cataName,
          catapdf,
          buyercatapdf,
          buyername,
          selectedUnit,
          selectedCurrency,
          selectedRate
        );
      } else if (selectedButton === 'button7') {
        handleDownloadPPT11();
      } else if (selectedButton === 'button8') {
        handleDownloadPPT11();
      } else if (selectedButton == 'button12') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT15(
          cata,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          catalogueCatProductSize,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm,
          // productMaterialName,
          // productInnerAndMaster,
          // productMoq,
          // ptech,
          // madeby
        );
      } else if (selectedButton == 'button14') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT17(
          cata,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          catalogueCatProductSize,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm,
          // productMaterialName,
          // productInnerAndMaster,
          // productMoq,
          // ptech,
          // madeby
        );
      } else if (selectedButton == 'button15') {
        const selected = getSelectedAttributes();
        const selectedItems =
          Array.isArray(selected) && selected.length > 0 ? selected.map(items => items) : '';
        handleDownloadPPT20(
          cata,
          buyercata,
          catappt,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          setLoadPPT,
          setOpenAttri,
          cataName,
          cataloguecatappt,
          label,
          catalogueCatProductSize,
          sizeshow,
          selectedUnit,
          selectedCurrency,
          selectedRate,
          ...selectedItems
          // productAlias,
          // productcategory,
          // productName,
          // producttype,
          // productdesc,
          // productsizerange,
          // productsize,
          // productfinish,
          // productntw,
          // productsalepri,
          // productremark,
          // productcbm,
          // productMaterialName,
          // productInnerAndMaster,
          // productMoq,
          // ptech,
          // madeby
        );
      }
      setSelectedButton(null);
    }
  };

  const [sizeshow, setSizeShow] = useState(false);
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details`);
      const json = await response.json();
      const extractedData = json.data[0].attributes.FreeSize;
      setSizeShow(extractedData);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };

  const [productAlias, setProductAlias] = useState(false);
  const [productName, setProductName] = useState(false);
  const [productsize, setProductSize] = useState(false);
  const [productsizerange, setProductsizerange] = useState(false);
  const [productfinish, setProductFinish] = useState(false);
  const [productntw, setProductNtw] = useState(false);
  const [productcbm, setProductCbm] = useState(false);
  const [productMaterialName, setProductMaterialName] = useState(false);
  const [productMoq, setProductMoq] = useState(false);
  const [productInnerAndMaster, setProductInnerAndMaster] = useState(false);

  const [productcategory, setProductCategory] = useState(false);
  const [producttype, setProductType] = useState(false);
  const [productdesc, setProductDesc] = useState(false);
  const [productcolor, setProductColor] = useState(false);
  const [productgrt, setProductGrt] = useState(false);
  const [productsalepri, setProductSalepri] = useState(false);
  const [productcurrency, setProductCurrency] = useState(false);
  const [productremark, setProductRemark] = useState(false);
  const [ptech, setPtech] = useState(false);
  const [madeby, setMadeby] = useState(false);

  useEffect(() => {
    fetchDataHeads();
  }, []);
  const fetchDataHeads = async () => {
    const response = await fetch(`${ip}/api/product-attributes`);
    const json = await response.json();
    const aliascdExists = json.data.some(
      item => item.attributes.Heads === 'aliascd' && item.attributes.status === true
    );
    const nameExists = json.data.some(
      item => item.attributes.Heads === 'productname' && item.attributes.status === true
    );
    const sizeExists = json.data.some(
      item => item.attributes.Heads === 'size' && item.attributes.status === true
    );
    const finishExists = json.data.some(
      item => item.attributes.Heads === 'finish' && item.attributes.status === true
    );
    const colorExists = json.data.some(
      item => item.attributes.Heads === 'color' && item.attributes.status === true
    );
    const ntwExists = json.data.some(
      item => item.attributes.Heads === 'netwgt' && item.attributes.status === true
    );
    const cbmExists = json.data.some(
      item => item.attributes.Heads === 'cbm' && item.attributes.status === true
    );
    const ptypeExists = json.data.some(
      item => item.attributes.Heads === 'prodtypecd' && item.attributes.status === true
    );
    const descExists = json.data.some(
      item => item.attributes.Heads === 'description' && item.attributes.status === true
    );
    const cateExists = json.data.some(
      item => item.attributes.Heads === 'catcd' && item.attributes.status === true
    );
    const grtwExists = json.data.some(
      item => item.attributes.Heads === 'grswgt' && item.attributes.status === true
    );
    const saleExists = json.data.some(
      item => item.attributes.Heads === 'saleprice' && item.attributes.status === true
    );
    const srangeExists = json.data.some(
      item => item.attributes.Heads === 'sizerange' && item.attributes.status === true
    );
    const matExists = json.data.some(
      item => item.attributes.Heads === 'material' && item.attributes.status === true
    );
    const innerExists = json.data.some(
      item => item.attributes.Heads === 'innmaster' && item.attributes.status === true
    );
    const moqExists = json.data.some(
      item => item.attributes.Heads === 'moq' && item.attributes.status === true
    );
    const currExists = json.data.some(
      item => item.attributes.Heads === 'currency' && item.attributes.status === true
    );
    const remarkExists = json.data.some(
      item => item.attributes.Heads === 'remark' && item.attributes.status === true
    );
    const ptechExists = json.data.some(
      item => item.attributes.Heads === 'ptech' && item.attributes.status === true
    );
    const madeExists = json.data.some(
      item => item.attributes.Heads === 'madeby' && item.attributes.status === true
    );

    setProductAlias(aliascdExists);
    setProductName(nameExists);
    setProductSize(sizeExists);
    setProductFinish(finishExists);
    setProductNtw(ntwExists);
    setProductCbm(cbmExists);
    setProductColor(colorExists);
    setProductType(ptypeExists);
    setProductDesc(descExists);
    setProductCategory(cateExists);
    setProductGrt(grtwExists);
    setProductSalepri(saleExists);
    setProductsizerange(srangeExists);
    setProductCurrency(currExists);
    setProductRemark(remarkExists);
    setPtech(ptechExists);
    setMadeby(madeExists);
    setProductMaterialName(matExists);
    setProductMoq(moqExists);
    setProductInnerAndMaster(innerExists);
  };
  useEffect(() => {
    fetchDataHeads().then(() => {
      setSelectedAttrs({
        productAlias: productAlias,
        productName: productName,
        productsize: productsize,
        productsizerange: productsizerange,
        productfinish: productfinish,
        productntw: productntw,
        productcbm: productcbm,
        productInnerAndMaster: productInnerAndMaster,
        productMaterialName: productMaterialName,
        productMoq: productMoq,
        productcategory: productcategory,
        producttype: producttype,
        productdesc: productdesc,
        productsalepri: productsalepri,
        productcurrency: productcurrency,
        productremark: productremark,
        ptech: ptech,
        madeby: madeby
      });
    });
  }, [openattri]); // run whenever modal opens

  const [open, setOpen] = useState(false);
  const handleOpen = key => {
    if (buyercata.length >= 1) {
      if (buyercataslide.length <= 1) {
        const byertemp = buyercataslide[0]?.TempName;
        if (byertemp === 'Format F1') {
          setOpenAttri(true);
        } else if (byertemp === 'Format F2') {
          handleDownloadPPT4();
        } else if (byertemp === 'Format F3') {
          handleDownloadPPT4();
        } else if (byertemp === 'Format F4') {
          setOpenAttri(true);
        } else if (byertemp === 'Format F5') {
          handleDownloadPPT5(
            data2,
            cata,
            catappt,
            watermark,
            mergeImagesWithWatermark,
            watermarkUrl,
            cataName,
            selectedUnit,
            selectedCurrency,
            selectedRate
          );
        } else if (byertemp === 'Format F6') {
          setOpenAttri(true);
        } else if (byertemp === 'Format F7') {
          // setOpenAttri(true);
        } else if (byertemp === 'Format F8') {
          // setOpenAttri(true);
        } else if (byertemp === 'Format F9') {
          // setOpenAttri(true);
        } else if (byertemp === 'Format F10') {
          // setOpenAttri(true);
        } else {
          setOpen(true);
        }
      } else {
        setOpen(true);
      }
    } else {
      if (slides.length <= 1) {
        if (slides[0]?.TempName == 'Format F1') {
          setOpenAttri(true);
        } else if (slides[0]?.TempName == 'Format F2') {
          setOpenAttri(true);
        } else if (slides[0]?.TempName == 'Format F3') {
          handleDownloadPPT4();
        } else if (slides[0]?.TempName == 'Format F4') {
          setOpenAttri(true);
        } else if (slides[0]?.TempName == 'Format F5') {
          handleDownloadPPT5(
            data2,
            cata,
            catappt,
            watermark,
            mergeImagesWithWatermark,
            watermarkUrl,
            cataName,
            selectedUnit,
            selectedCurrency,
            selectedRate
          );
        } else if (slides[0]?.TempName == 'Format F6') {
          setOpenAttri(true);
        } else if (slides[0]?.TempName == 'Format F7') {
          setOpenAttri(true);
        } else if (slides[0]?.TempName == 'Format F8') {
          setOpenAttri(true);
        } else {
          setOpen(true);
        }
      } else {
        setOpen(true);
      }
    }
  };
  const [openp, setOpenp] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openFormatModal, setOpenFormatModal] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState(null); // 'F1' or 'F2'
  const handleOpenp = async key => {
    setIsLoading(true); // 🔹 show loader

    try {
      if (buyercatapdf.length >= 1) {
        if (buyercataslidepdf.length <= 1) {
          const byertemp = buyercataslidepdf[0]?.TempName;
          if (byertemp === 'Format F1') {
            await handleDownloadPDF(
              cata,
              cataloguecatappt,
              label,
              data2,
              watermark,
              mergeImagesWithWatermark,
              watermarkUrl,
              cataName,
              selectedUnit,
              selectedCurrency,
              selectedRate
            );
          } else if (byertemp === 'Format F2') {
            await handleDownloadPDF2(
              cata,
              cataloguecatappt,
              label,
              data2,
              watermark,
              mergeImagesWithWatermark,
              watermarkUrl,
              cataName,
              catapdf,
              buyercatapdf,
              buyername,
              selectedUnit,
              selectedCurrency,
              selectedRate
            );
          } else {
            setOpenp(true);
          }
        } else {
          setOpenp(true);
        }
      } else {
        if (slidespdf.length <= 1) {
          if (slidespdf[0]?.TempName == 'Format F1') {
            setSelectedFormat('F1');
            setOpenFormatModal(true);
            return;
            await handleDownloadPDF(
              cata,
              cataloguecatappt,
              label,
              data2,
              watermark,
              mergeImagesWithWatermark,
              watermarkUrl,
              cataName,
              selectedUnit,
              selectedCurrency,
              selectedRate
            );
          } else if (slidespdf[0]?.TempName == 'Format F2') {
            setSelectedFormat('F2');
            setOpenFormatModal(true);
            return;
            await handleDownloadPDF2(
              cata,
              cataloguecatappt,
              label,
              data2,
              watermark,
              mergeImagesWithWatermark,
              watermarkUrl,
              cataName,
              catapdf,
              buyercatapdf,
              buyername,
              selectedUnit,
              selectedCurrency,
              selectedRate
            );
          } else {
            setOpenp(true);
          }
        } else {
          setOpenp(true);
        }
      }
    } catch (error) {
      console.error('Download failed', error);
    } finally {
      setIsLoading(false); // 🔹 hide loader AFTER ALL PDFs are saved
    }
  };

  const handleClosep = () => setOpenp(false);

  ///////////////Excel Modal///////////////
  const [selectedRowDataexcel, setSelectedRowDataexcel] = useState(null);

  const handleDownloadexcel = value => {
    setSelectedRowDataexcel(value);

    if (buyercataexcel.length >= 1) {
      if (buyercataslideexcel.length <= 1) {
        const byertemp = buyercataslideexcel[0]?.TempName;
        if (byertemp === 'Format F1') {
          downloadExcelData(
            value,
            csvData,
            catappt,
            cataexcel,
            excel,
            watermark,
            watermarkUrl,
            mergeImagesWithWatermark,
            cataName,
            productdesc,
            productName,
            productcategory,
            productntw,
            productfinish,
            selectedUnit,
            selectedCurrency,
            selectedRate
          );
        } else if (byertemp === 'Format F2') {
          downloadExcelData2(
            value,
            csvData,
            data2,
            watermark,
            watermarkUrl,
            mergeImagesWithWatermark,
            cataName,
            productdesc,
            productName,
            productcategory,
            productntw,
            productfinish,
            selectedUnit,
            selectedCurrency,
            selectedRate
          );
        } else {
          setOpenp(true);
        }
      } else {
        setOpenp(true);
      }
    } else {
      if (slidesexcel.length <= 1) {
        if (slidesexcel[0]?.TempName == 'Format F1') {
          downloadExcelData(
            value,
            csvData,
            catappt,
            cataexcel,
            excel,
            watermark,
            watermarkUrl,
            mergeImagesWithWatermark,
            cataName,
            productdesc,
            productName,
            productcategory,
            productntw,
            productfinish,
            selectedUnit,
            selectedCurrency,
            selectedRate
          );
        } else if (slidesexcel[0]?.TempName == 'Format F2') {
          downloadExcelData2(
            value,
            csvData,
            data2,
            watermark,
            watermarkUrl,
            mergeImagesWithWatermark,
            cataName,
            productdesc,
            productName,
            productcategory,
            productntw,
            productfinish,
            selectedUnit,
            selectedCurrency,
            selectedRate
          );
        } else {
          setOpenexcel(true);
        }
      } else {
        setOpenexcel(true);
      }
    }
  };

  const [openexcel, setOpenexcel] = useState(false);
  const handleCloseexcel = () => setOpenexcel(false);

  //// copy link
  const [textToCopy, setTextToCopy] = useState('');
  const [isCopied, setIsCopied] = useState(false);
  const handleCopy = () => {
    setIsCopied(true);
    // You can add additional handling or feedback here.
  };
  //// copy link

  ///generate link
  const [link, setLink] = useState(false);
  const handlelinkOpen = () => setLink(true);
  const handlelinkClose = () => setLink(false);
  const [showCopyButton, setShowCopyButton] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]); // State to hold the selected date range

  // Function to handle changes in the selected date range
  const handleDateRangeChange = value => {
    setDateRange(value);
  };

  const [glogin, setGlogin] = useState({
    username: '',
    password: '',
    buyername: '',
    Timefrom: '',
    Timeto: '',
    merchant: '',
    Type: '',
    Status: '',
    buyercode: '',
    typecode: '',
    typename: ''
  });
  const handleInputChange = (inputName, event, index) => {
    let value;
    if (event && event.target) {
      // If event is not null and has a target property
      value = event.target.value;
    } else {
      // Handle cases where event is null or doesn't have a target property
      value = event;
    }
    setGlogin({ ...glogin, [inputName]: value });
  };
  const buyercode = cataloguedata.map(item => item.attributes.BuyerName);
  const catacode = cataloguedata.map(item => item.attributes.CatalogueCode);
  const cataname = cataloguedata.map(item => item.attributes.catalogueName);

  function checkCataCode(cataCodes) {
    for (let i = 0; i < cataCodes.length; i++) {
      const cataCode = cataCodes[i];
      if (typeof cataCode.startsWith('CATLG')) {
        return `Catalogue`;
      }
    }
    return 'N/A';
  }

  const result = checkCataCode(catacode);
  const [clientdata, setClientData] = useState(0);
  const [clientdatacheck, setClientDataCheck] = useState([]);
  useEffect(() => {
    fetchDataClint();
  }, []);
  const fetchDataClint = async () => {
    const response = await fetch(`${ip}/api/client-logins?populate=*`);
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/client-logins?populate=*&pagination[page]=${page}`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    setClientDataCheck(allData);
    setClientData(json.meta.pagination.total);
  };
  const toaster = useToaster();
  const generateClintCode = () => {
    const nextCode = clientdata + 1;
    return `CLI-${nextCode.toString().padStart(3, '0')}`;
  };
  let nextCategoryCode1 = generateClintCode();
  const logindetails = `${ip}/api/client-logins`;
  const handleOkClick = e => {
    e.preventDefault();
    if (glogin.username === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Username
        </Message>,
        { placement: 'topEnd' }
      );
    } else if (clientdatacheck.find(item => item.attributes.username === glogin.username)) {
      toaster.push(
        <Message showIcon type="error">
          Username Already Taken. Try Different
        </Message>,
        { placement: 'topEnd' }
      );
    } else {
      nextCategoryCode1 = generateClintCode();
      const nextCategoryCode = nextCategoryCode1;
      const generatedLink = `http://192.168.1.25:3100/apptwo?username=c54ta76logue5$5&password=p$fn5&#mgi%&`;
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          ...glogin,
          buyername: '',
          Timefrom: dateRange[0] ? dateRange[0].toISOString().slice(0, 10) : null,
          Timeto: dateRange[1] ? dateRange[1].toISOString().slice(0, 10) : null,
          merchant: '',
          Type: result,
          Status: 'Active',
          buyercode: String(buyercode),
          typecode: String(catacode),
          typename: String(cataname),
          client_id: nextCategoryCode
        })
      );
      fetch(logindetails, {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          // Refresh page after 2 seconds (2000 milliseconds)
        })
        .catch(error => {
          console.error(error);
        });
      setTextToCopy(generatedLink);
      // setShowCopyButton(true);
      handlelinkClose();
    }
  };
  ///generate link

  const [to, setTo] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [attachment, setAttachment] = useState<{
    filename: string | null;
    contentType: string | null;
    content: string | null;
  }>({
    filename: null,
    contentType: null,
    content: null
  });
  const ipp = globalIP;
  const handleAttachmentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      // Check file size (max 10MB)
      if (file.size > 10 * 1024 * 1024) {
        toaster.push(
          <Message showIcon type="warning">
            File size should be less than 10MB
          </Message>,
          { placement: 'topEnd' }
        );
        return;
      }

      const reader = new FileReader();
      reader.onload = event => {
        const base64Content = event.target?.result?.toString().split(',')[1] || '';
        setAttachment({
          filename: file.name,
          contentType: file.type,
          content: base64Content
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const [openq, setOpenq] = useState(false);
  const [qrValue, setQrValue] = useState('https://google.com');
  return (
    <>
      {isLoading && (
        <div className="loader-overlay">
          <div className="spinner" />
          <p>Downloading PDF...</p>
        </div>
      )}

      <Container className="main">
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction="column" alignItems="flex-start">
            <h3 className="title">Catalogue is here</h3>
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to={`/${ugr}/dashboard`}>Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item active>Catalogue </Breadcrumb.Item>
            </Breadcrumb>
          </Stack>

          {isCopied ? <Message type="success">Copied!</Message> : null}
        </Stack>
        <Divider style={{ marginTop: 0, marginBottom: '5px' }} />

        {/* {watermarkAccess && cata.length > 0 && (
          <Checkbox checked={watermark} onChange={() => setWatermark(!watermark)}>
            Include Water-Mark
          </Checkbox>
        )} */}
        <Stack direction="column" alignItems="center" spacing={5} className="gnrt-lyut">
          {cata.length == 0 ? (
            <Loader
              speed="normal"
              content="Formats loading..."
              vertical
              style={{ marginTop: '20px' }}
            />
          ) : (
            <ButtonGroup
              style={{
                gap: 20
              }}
              justified
              className="generate-cate"
            >
              <Stack direction="column" spacing={10}>
                <img
                  src={img2}
                  style={{ width: '50%', cursor: 'pointer' }}
                  onClick={() => handleOpen()}
                />
                {/* <Stack spacing={10} style={{ fontSize: '24px' }}>
                  <Icon as={VisibleIcon} style={{ cursor: 'pointer', color: 'red' }} />
                  <Icon as={EditIcon} style={{ cursor: 'pointer' }} />
                </Stack> */}
              </Stack>

              <Stack direction="column" spacing={10}>
                <img
                  src={img3}
                  style={{ width: '50%', cursor: 'pointer' }}
                  onClick={() => handleDownloadexcel(cataloguecatappt)}
                />
                {/* <Stack spacing={10} style={{ fontSize: '24px' }}>
                  <Icon as={VisibleIcon} style={{ cursor: 'pointer', color: 'red' }} />
                  <Icon as={EditIcon} style={{ cursor: 'pointer' }} />
                </Stack> */}
              </Stack>

              <Stack direction="column" spacing={10}>
                <img
                  src={img4}
                  style={{ width: '50%', cursor: 'pointer', borderRadius: '8px' }}
                  onClick={() => handleOpenp()}
                />
                {/* <Stack spacing={10} style={{ fontSize: '24px' }}>
                  <Icon as={VisibleIcon} style={{ cursor: 'pointer', color: 'red' }} />
                  <Icon as={EditIcon} style={{ cursor: 'pointer' }} />
                </Stack> */}
              </Stack>

              {/* <Button appearance='ghost' color='cyan' style={{ padding: 0 }} onClick={() => handleDownloadexcel(csvData)} >Download Excel</Button>
            <Button appearance='default' active onClick={() => handleOpenp('lg')}>Download PDF</Button> */}
            </ButtonGroup>
          )}
          <img src={img} style={{ width: 250, opacity: 0.3 }} />
          {/* <Form.ControlLabel>
            <b>Copy the link below and share it with the buyer to view web catalogue </b>
          </Form.ControlLabel> */}
          {/* <Form.ControlLabel>We will update you whenever the buyer opens the catalogue link, shortlists, products or share any queries</Form.ControlLabel> */}
          {(user.CATLinkSecurity === true || user.Category === 'Admin') && (
            <Stack direction="row" spacing={10}>
              <Panel bordered>
                <Stack spacing={90}>
                  <Input
                    value={linkGenrate ? `${data2[0]?.attributes.GLink}${linkGenrate}` : ''}
                    readOnly
                    style={{ width: '140%' }}
                  />
                  {showCopyButton && (
                    <CopyToClipboard
                      text={linkGenrate ? `${data2[0]?.attributes.GLink}${linkGenrate}` : ''}
                      onCopy={handleCopy}
                    >
                      <Button appearance="primary" color="cyan">
                        Copy Link
                      </Button>
                    </CopyToClipboard>
                  )}
                  {companytype == 'Domestic' ? (
                    <>
                      {!showCopyButton && (
                        <Button
                          appearance="primary"
                          color="cyan"
                          onClick={() => setOpenWithHeader(true)}
                        >
                          Generate Link
                        </Button>
                      )}
                    </>
                  ) : (
                    <>
                      {!showCopyButton && (
                        <Button
                          appearance="primary"
                          color="cyan"
                          onClick={() => setOpenGenerateSlider(true)}
                        >
                          Generate Link
                        </Button>
                      )}
                    </>
                  )}
                </Stack>
              </Panel>
              <IconButton
                size="md"
                icon={<EmailIcon />}
                active
                style={{ marginRight: '10px', color: 'red' }}
                onClick={() => handleOpenn('sm')}
              />
            </Stack>
          )}
        </Stack>
      </Container>

      <Modal open={link} onClose={handlelinkClose} size="md">
        <Modal.Header>
          <Modal.Title>
            <b>Fill the Details</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FlexboxGrid justify="space-around">
            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
              <b>Username</b>
              <Input
                id="username"
                name="username"
                value={glogin && glogin.username ? glogin.username : ''}
                onChange={value => handleInputChange('username', value, 0)}
              />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
              <b>Password</b>
              <Input
                id="password"
                type="password"
                name="password"
                value={glogin && glogin.password ? glogin.password : ''}
                onChange={value => handleInputChange('password', value, 0)}
              />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
              <b>Date Range</b>
              <DateRangePicker
                id="dateRange"
                value={dateRange}
                format="dd/MM/yyyy"
                onChange={handleDateRangeChange}
              />
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handlelinkClose} appearance="subtle" active>
            Cancel
          </Button>
          <Button onClick={handleOkClick} appearance="primary" color="cyan">
            Generate
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ////////Excel modal////////// */}
      <Drawer size="xs" open={openexcel} onClose={handleCloseexcel}>
        <Drawer.Header
          style={{
            display: 'flex',
            flexDirection: 'column'
            // justifyContent: "space-between",
            // alignItems: "flex-start",
            // paddingBottom: 16
          }}
        >
          {/* 🔹 Left - Title */}
          <Drawer.Title style={{ margin: 0 }}>
            <b>Excel Formats</b>
          </Drawer.Title>

          {/* 🔹 Right - Dropdown Column Layout */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'auto auto',
              gap: '12px 20px',
              alignItems: 'center'
            }}
          >
            {/* Unit */}
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: 12, fontWeight: 500 }}>
                Unit <span style={{ color: 'red' }}>*</span>
              </span>
              <SelectPicker
                data={unitOptions}
                value={selectedUnit}
                onChange={setSelectedUnit}
                placeholder="Select"
                style={{ width: 150 }}
                size="sm"
                searchable={false}
              />
            </div>

            {/* Currency */}
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: 12, fontWeight: 500 }}>Currency</span>
              <SelectPicker
                data={currencyOptions}
                value={selectedCurrency}
                onChange={setSelectedCurrency}
                placeholder="Select"
                style={{ width: 150 }}
                size="sm"
                searchable={false}
              />
            </div>
          </div>
        </Drawer.Header>
        <Drawer.Body>
          <Panel>
            <FlexboxGrid justify="space-around">
              {slidesexcel.some(item => item.TempName == 'Format F1') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      downloadExcelData(
                        selectedRowDataexcel,
                        csvData,
                        catappt,
                        cataexcel,
                        excel,
                        watermark,
                        watermarkUrl,
                        mergeImagesWithWatermark,
                        cataName,
                        productdesc,
                        productName,
                        productcategory,
                        productntw,
                        productfinish,
                        selectedUnit,
                        selectedCurrency,
                        selectedRate
                      );
                    }}
                    className="pdf-layout"
                  >
                    <img src={excel_one} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slidesexcel.some(item => item.TempName == 'Format F2') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      downloadExcelData2(
                        selectedRowDataexcel,
                        csvData,
                        data2,
                        watermark,
                        watermarkUrl,
                        mergeImagesWithWatermark,
                        cataName,
                        productdesc,
                        productName,
                        productcategory,
                        productntw,
                        productfinish,
                        selectedUnit,
                        selectedCurrency,
                        selectedRate
                      );
                    }}
                    className="pdf-layout"
                  >
                    <img src={excel_two} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {buyercataslidepdf.some(item => item.TempName == 'Format F2') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      downloadExcelData(
                        selectedRowDataexcel,
                        csvData,
                        catappt,
                        cataexcel,
                        excel,
                        watermark,
                        watermarkUrl,
                        mergeImagesWithWatermark,
                        cataName,
                        productdesc,
                        productName,
                        productcategory,
                        productntw,
                        productfinish,
                        selectedUnit,
                        selectedCurrency,
                        selectedRate
                      );
                    }}
                    className="pdf-layout"
                  >
                    <img src={excel_one} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {buyercataslidepdf.some(item => item.TempName == 'Format F2') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      downloadExcelData2(
                        selectedRowDataexcel,
                        csvData,
                        data2,
                        watermark,
                        watermarkUrl,
                        mergeImagesWithWatermark,
                        cataName,
                        productdesc,
                        productName,
                        productcategory,
                        productntw,
                        productfinish,
                        selectedUnit,
                        selectedCurrency,
                        selectedRate
                      );
                    }}
                    className="pdf-layout"
                  >
                    <img src={excel_two} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
            </FlexboxGrid>
          </Panel>
        </Drawer.Body>
      </Drawer>

      <Drawer size="xs" open={open} onClose={() => setOpen(false)}>
        <Drawer.Header
          style={{
            display: 'flex',
            flexDirection: 'column'
            // justifyContent: "space-between",
            // alignItems: "flex-start",
            // paddingBottom: 16
          }}
        >
          {/* 🔹 Left - Title */}
          <Drawer.Title style={{ margin: 0 }}>
            <b>PPT Formats</b>
          </Drawer.Title>

          {/* 🔹 Right - Dropdown Column Layout */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'auto auto',
              gap: '12px 20px',
              alignItems: 'center'
            }}
          >
            {/* Unit */}
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: 12, fontWeight: 500 }}>
                Unit <span style={{ color: 'red' }}>*</span>
              </span>
              <SelectPicker
                data={unitOptions}
                value={selectedUnit}
                onChange={setSelectedUnit}
                placeholder="Select"
                style={{ width: 150 }}
                size="sm"
                searchable={false}
              />
            </div>

            {/* Currency */}
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: 12, fontWeight: 500 }}>Currency</span>
              <SelectPicker
                data={currencyOptions}
                value={selectedCurrency}
                onChange={setSelectedCurrency}
                placeholder="Select"
                style={{ width: 150 }}
                size="sm"
                searchable={false}
              />
            </div>
          </div>
        </Drawer.Header>
        <Drawer.Body>
          <Panel>
            <FlexboxGrid justify="space-around">
              {slides.some(item => item.TempName == 'Format F1') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => handleOpenAttributes('button1')}
                    // onClick={() => {
                    //   setOpenAttri(true);
                    //   setSelectedButton('button1');
                    // }}
                    className="pdf-layout"
                  >
                    <img src={ppt_one} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format F2') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => handleOpenAttributes('button2')}
                    // onClick={() => {
                    //   setOpenAttri(true);
                    //   setSelectedButton('button2');
                    // }}
                    className="pdf-layout"
                  >
                    <img src={ppt_two} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format F3') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() =>
                      handleDownloadPPT4(
                        cata,
                        data2,
                        buyercata,
                        catappt,
                        watermark,
                        mergeImagesWithWatermark,
                        watermarkUrl,
                        cataName,
                        selectedUnit,
                        selectedCurrency,
                        selectedRate
                      )
                    }
                    className="pdf-layout"
                  >
                    <img src={ppt_three} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format F4') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => handleOpenAttributes('button3')}
                    // onClick={() => {
                    //   setOpenAttri(true);
                    //   setSelectedButton('button3'); //this is 4th ppt button
                    // }}
                    className="pdf-layout"
                  >
                    <img src={ppt_four} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format F5') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() =>
                      handleDownloadPPT5(
                        data2,
                        cata,
                        catappt,
                        watermark,
                        mergeImagesWithWatermark,
                        watermarkUrl,
                        cataName,
                        selectedUnit,
                        selectedCurrency,
                        selectedRate
                      )
                    }
                    className="pdf-layout"
                  >
                    <img src={ppt_three} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format F6') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => handleOpenAttributes('button4')}
                    // onClick={() => {
                    //   setOpenAttri(true);
                    //   setSelectedButton('button4');
                    // }}
                    className="pdf-layout"
                  >
                    <img src={ppt_six} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format F7') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() =>
                      handleDownloadPPT11(
                        cata,
                        data2,
                        catalogueCatProductSize,
                        colordata,
                        watermark,
                        mergeImagesWithWatermark,
                        watermarkUrl,
                        cataloguecatappt,
                        label,
                        setLoadPPT,
                        buyercata,
                        catappt,
                        selectedUnit,
                        selectedCurrency,
                        selectedRate
                      )
                    }
                    className="pdf-layout"
                  >
                    {/* 'Format F7' */}
                    <img src={ppt_ten} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format F8') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() =>
                      handleDownloadPPT13(
                        cata,
                        data2,
                        colordata,
                        catalogueCatProductSize,
                        watermark,
                        mergeImagesWithWatermark,
                        watermarkUrl,
                        cataloguecatappt,
                        label,
                        buyercata,
                        catappt,
                        selectedUnit,
                        selectedCurrency,
                        selectedRate
                      )
                    }
                    className="pdf-layout"
                  >
                    {' '}
                    {/* // this is 8th formate */}
                    {/* 'Format F8' */}
                    <img src={ppt_eleven} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format F9') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  {/* <p>f9</p> */}
                  <Button
                    block
                    onClick={() =>
                      handleDownloadPPT14(
                        cata,
                        colordata,
                        catalogueCatProductSize,
                        watermark,
                        mergeImagesWithWatermark,
                        watermarkUrl,
                        cataloguecatappt,
                        label,
                        buyercata,
                        catappt,
                        selectedUnit,
                        selectedCurrency,
                        selectedRate
                      )
                    }
                    className="pdf-layout"
                  >
                    {/* 'Format F9' */}
                    <img src={ppt_ten} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format F10') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() =>
                      handleDownloadPPT12(
                        cata,
                        colordata,
                        catalogueCatProductSize,
                        watermark,
                        mergeImagesWithWatermark,
                        watermarkUrl,
                        cataloguecatappt,
                        label,
                        buyercata,
                        catappt,
                        selectedUnit,
                        selectedCurrency,
                        selectedRate
                      )
                    }
                    className="pdf-layout"
                  >
                    {/* 'Format F10' */}
                    <img src={ppt_eleven} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {/* {slides.some(item => item.TempName == 'Format F8') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      setOpenAttri(true);
                      setSelectedButton('button7');
                    }}
                    className="pdf-layout"
                  >
                    <img src={ppt_eleven} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )} */}
              {slides.some(item => item.TempName == 'Format Two F1') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() =>
                      handleDownloadPPT8(
                        cata,
                        catappt,
                        watermark,
                        mergeImagesWithWatermark,
                        watermarkUrl,
                        cataName,
                        cataloguecatappt,
                        label,
                        productAlias,
                        productdesc,
                        buyercata,
                        selectedUnit,
                        selectedCurrency,
                        selectedRate
                      )
                    }
                    className="pdf-layout"
                  >
                    <img src={ppt_seven} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format Three F1') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() =>
                      handleDownloadPPT7(
                        cata,
                        catappt,
                        watermark,
                        mergeImagesWithWatermark,
                        watermarkUrl,
                        cataName,
                        buyercata,
                        selectedUnit,
                        selectedCurrency,
                        selectedRate
                      )
                    }
                    className="pdf-layout"
                  >
                    <img src={ppt_eight} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format Four F1') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() =>
                      handleDownloadPPT9(
                        cata,
                        buyercata,
                        catappt,
                        watermark,
                        mergeImagesWithWatermark,
                        watermarkUrl,
                        cataName,
                        label,
                        selectedUnit,
                        selectedCurrency,
                        selectedRate
                      )
                    }
                    className="pdf-layout"
                  >
                    <img src={ppt_nine} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format F12') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      setOpenAttri(true);
                      setSelectedButton('button12');
                    }}
                    className="pdf-layout"
                  >
                    <img src={ppt_twelve} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format F13') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() =>
                      handleDownloadPPT16(
                        cata,
                        catappt,
                        watermark,
                        mergeImagesWithWatermark,
                        watermarkUrl,
                        cataName,
                        buyercata,
                        setLoadPPT,
                        selectedUnit,
                        selectedCurrency,
                        selectedRate
                      )
                    }
                    className="pdf-layout"
                  >
                    <img src={ppt_therteen} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format F15') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() =>
                      handleDownloadPPT18(
                        cata,
                        catappt,
                        watermark,
                        mergeImagesWithWatermark,
                        watermarkUrl,
                        cataName,
                        buyercata,
                        setLoadPPT,
                        selectedUnit,
                        selectedCurrency,
                        selectedRate
                      )
                    }
                    className="pdf-layout"
                  >
                    <img src={ppt_forrteen} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format F14') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      setOpenAttri(true);
                      setSelectedButton('button14');
                    }}
                    className="pdf-layout"
                  >
                    <img src={ppt_seventeen} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format F16') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() =>
                      handleDownloadPPT19(
                        cata,
                        catappt,
                        watermark,
                        mergeImagesWithWatermark,
                        watermarkUrl,
                        cataName,
                        buyercata,
                        setLoadPPT,
                        selectedUnit,
                        selectedCurrency,
                        selectedRate
                      )
                    }
                    className="pdf-layout"
                  >
                    <img src={ppt_fifteen} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format F17') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => handleOpenAttributes('button15')}
                    // onClick={() => {
                    //   setOpenAttri(true);
                    //   setSelectedButton('button15');
                    // }}
                    className="pdf-layout"
                  >
                    <img src={ppt_sixteen} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {buyercataslide.some(item => item.TempName == 'Format F1') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => handleOpenAttributes('button1')}
                    // onClick={() => {
                    //   setOpenAttri(true);
                    //   setSelectedButton('button1');
                    // }}
                    className="pdf-layout"
                  >
                    <img src={ppt_one} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {buyercataslide.some(item => item.TempName == 'Format F2') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => handleOpenAttributes('button2')}
                    // onClick={() => {
                    //   setOpenAttri(true);
                    //   setSelectedButton('button2');
                    // }}
                    className="pdf-layout"
                  >
                    <img src={ppt_two} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {buyercataslide.some(item => item.TempName == 'Format F3') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => handleOpenAttributes('button3')}
                    // onClick={() => {
                    //   setOpenAttri(true);
                    //   setSelectedButton('button3'); //this is 4th ppt button
                    // }}
                    className="pdf-layout"
                  >
                    <img src={ppt_three} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {buyercataslide.some(item => item.TempName == 'Format F4') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => handleOpenAttributes('button4')}
                    // onClick={() => {
                    //   setOpenAttri(true);
                    //   setSelectedButton('button4');
                    // }}
                    className="pdf-layout"
                  >
                    <img src={ppt_four} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {buyercataslide.some(item => item.TempName == 'Format F5') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      setOpenAttri(true);
                      setSelectedButton('button5');
                    }}
                    className="pdf-layout"
                  >
                    <img src={ppt_three} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {buyercataslide.some(item => item.TempName == 'Format F6') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      setOpenAttri(true);
                      setSelectedButton('button6');
                    }}
                    className="pdf-layout"
                  >
                    <img src={ppt_six} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
            </FlexboxGrid>
          </Panel>
        </Drawer.Body>
      </Drawer>

      <Drawer size="xs" open={openp} onClose={handleClosep}>
        <Drawer.Header
          style={{
            display: 'flex',
            flexDirection: 'column'
            // justifyContent: "space-between",
            // alignItems: "flex-start",
            // paddingBottom: 16
          }}
        >
          {/* 🔹 Left - Title */}
          <Drawer.Title style={{ margin: 0 }}>
            <b>PDF Formats</b>
          </Drawer.Title>

          {/* 🔹 Right - Dropdown Column Layout */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'auto auto',
              gap: '12px 20px',
              alignItems: 'center'
            }}
          >
            {/* Unit */}
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: 12, fontWeight: 500 }}>
                Unit <span style={{ color: 'red' }}>*</span>
              </span>
              <SelectPicker
                data={unitOptions}
                value={selectedUnit}
                onChange={setSelectedUnit}
                placeholder="Select"
                style={{ width: 150 }}
                size="sm"
                searchable={false}
              />
            </div>

            {/* Currency */}
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: 12, fontWeight: 500 }}>Currency</span>
              <SelectPicker
                data={currencyOptions}
                value={selectedCurrency}
                onChange={setSelectedCurrency}
                placeholder="Select"
                style={{ width: 150 }}
                size="sm"
                searchable={false}
              />
            </div>
          </div>
        </Drawer.Header>
        <Drawer.Body>
          <Panel>
            <FlexboxGrid justify="space-around">
              {slidespdf.some(item => item.TempName == 'Format F1') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      handleDownloadPDF(
                        cata,
                        cataloguecatappt,
                        label,
                        data2,
                        watermark,
                        mergeImagesWithWatermark,
                        watermarkUrl,
                        cataName,
                        selectedUnit,
                        selectedCurrency,
                        selectedRate
                      );
                    }}
                    className="pdf-layout"
                  >
                    <img src={pdf_one} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slidespdf.some(item => item.TempName == 'Format F2') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      handleDownloadPDF2(
                        cata,
                        cataloguecatappt,
                        label,
                        data2,
                        watermark,
                        mergeImagesWithWatermark,
                        watermarkUrl,
                        cataName,
                        catapdf,
                        buyercatapdf,
                        buyername,
                        selectedUnit,
                        selectedCurrency,
                        selectedRate
                      );
                    }}
                    className="pdf-layout"
                  >
                    <img src={pdf_two} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {buyercataslidepdf.some(item => item.TempName == 'Format F1') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      handleDownloadPDF(
                        cata,
                        cataloguecatappt,
                        label,
                        data2,
                        watermark,
                        mergeImagesWithWatermark,
                        watermarkUrl,
                        cataName,
                        selectedUnit,
                        selectedCurrency,
                        selectedRate
                      );
                    }}
                    className="pdf-layout"
                  >
                    <img src={pdf_one} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {buyercataslidepdf.some(item => item.TempName == 'Format F2') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      handleDownloadPDF2(
                        cata,
                        cataloguecatappt,
                        label,
                        data2,
                        watermark,
                        mergeImagesWithWatermark,
                        watermarkUrl,
                        cataName,
                        catapdf,
                        buyercatapdf,
                        buyername,
                        selectedUnit,
                        selectedCurrency,
                        selectedRate
                      );
                    }}
                    className="pdf-layout"
                  >
                    <img src={pdf_two} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
            </FlexboxGrid>
          </Panel>
        </Drawer.Body>
      </Drawer>

      <Modal size={sizee} open={openn} onClose={handleClose}>
        <Modal.Header>
          <Modal.Title>
            <b>Email</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ justifyContent: 'center' }}>
          <Panel style={{ width: '60%', margin: 'auto' }}>
            <Form>
              <FormControlLabel>To:</FormControlLabel>
              <Input value={to} onChange={value => setTo(value)} />
              <FormControlLabel>Subject</FormControlLabel>
              <Input value={subject} onChange={value => setSubject(value)} />
              <FormControlLabel>Body</FormControlLabel>
              <Form.Control
                rows={5}
                name="textarea"
                accepter={Textarea}
                value={message}
                onChange={value => setMessage(value)}
              />
              <FormControlLabel>Attachment</FormControlLabel>
              <input type="file" onChange={handleAttachmentChange} style={{ opacity: 1 }} />
            </Form>
          </Panel>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose} appearance="subtle" active>
            Cancel
          </Button>
          <Button onClick={sendemail} appearance="primary" color="cyan" loading={loading}>
            Send
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        open={openattri}
        onClose={() => setOpenAttri(false)}
        onExited={() => setMaxAttributes(15)}
      >
        <Modal.Header>
          <Modal.Title>Custom Attributes</Modal.Title>
          <div className="mt-2">
            <div className="flex justify-between text-xs text-gray-700 mb-1">
              <span>Selected:{selectedCount}</span> &nbsp;&nbsp;
              <span>Max:{maxAttributes}</span>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <FlexboxGrid justify="space-between">
            {/** Product Name */}
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox
                checked={selectedAttrs.productName}
                onChange={() => toggleAttr('productName')}
              >
                {label[0]?.attributes.ProductName}
              </Checkbox>
            </FlexboxGrid.Item>

            {/** Alias Code */}
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox
                checked={selectedAttrs.productAlias}
                onChange={() => toggleAttr('productAlias')}
              >
                {label[0]?.attributes.AliasCode}
              </Checkbox>
            </FlexboxGrid.Item>

            {sizeshow ? (
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={selectedAttrs.productsizerange}
                  onChange={() => toggleAttr('productsizerange')}
                >
                  {label[0]?.attributes.SizeRange}
                </Checkbox>
              </FlexboxGrid.Item>
            ) : (
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={selectedAttrs.productsize}
                  onChange={() => toggleAttr('productsize')}
                >
                  {label[0]?.attributes.Sizeunit}
                </Checkbox>
              </FlexboxGrid.Item>
            )}

            {/** Finish */}
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox
                checked={selectedAttrs.productfinish}
                onChange={() => toggleAttr('productfinish')}
              >
                {label[0]?.attributes.finish}
              </Checkbox>
            </FlexboxGrid.Item>

            {/** Net Weight */}
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox
                checked={selectedAttrs.productntw}
                onChange={() => toggleAttr('productntw')}
              >
                {label[0]?.attributes.NetWgt}
              </Checkbox>
            </FlexboxGrid.Item>

            {/** CBM */}
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox
                checked={selectedAttrs.productcbm}
                onChange={() => toggleAttr('productcbm')}
              >
                {label[0]?.attributes.cbm}
              </Checkbox>
            </FlexboxGrid.Item>

            {/** Inner/Master */}
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox
                checked={selectedAttrs.productInnerAndMaster}
                onChange={() => toggleAttr('productInnerAndMaster')}
              >
                Inner/Master
              </Checkbox>
            </FlexboxGrid.Item>

            {/** Material Name */}
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox
                checked={selectedAttrs.productMaterialName}
                onChange={() => toggleAttr('productMaterialName')}
              >
                {label[0]?.attributes.MaterialName}
              </Checkbox>
            </FlexboxGrid.Item>

            {/** MOQ */}
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox
                checked={selectedAttrs.productMoq}
                onChange={() => toggleAttr('productMoq')}
              >
                {label[0]?.attributes.MOQ}
              </Checkbox>
            </FlexboxGrid.Item>

            {/** Category */}
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox
                checked={selectedAttrs.productcategory}
                onChange={() => toggleAttr('productcategory')}
              >
                {label[0]?.attributes.Category}
              </Checkbox>
            </FlexboxGrid.Item>

            {/** Product Type */}
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox
                checked={selectedAttrs.producttype}
                onChange={() => toggleAttr('producttype')}
              >
                {label[0]?.attributes.ProductType}
              </Checkbox>
            </FlexboxGrid.Item>

            {/** Description */}
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox
                checked={selectedAttrs.productdesc}
                onChange={() => toggleAttr('productdesc')}
              >
                {label[0]?.attributes.Description}
              </Checkbox>
            </FlexboxGrid.Item>

            {/** Sale Price (conditional) */}
            {(user.CATShwPrice === true || user.Category === 'Admin') && (
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={selectedAttrs.productsalepri}
                  onChange={() => toggleAttr('productsalepri')}
                >
                  {label[0]?.attributes.SalePrice}
                </Checkbox>
              </FlexboxGrid.Item>
            )}

            {/** Currency */}
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox
                checked={selectedAttrs.productcurrency}
                onChange={() => toggleAttr('productcurrency')}
              >
                {label[0]?.attributes.Currency}
              </Checkbox>
            </FlexboxGrid.Item>

            {/** Product Remark */}
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox
                checked={selectedAttrs.productremark}
                onChange={() => toggleAttr('productremark')}
              >
                {label[0]?.attributes.ProductRemark}
              </Checkbox>
            </FlexboxGrid.Item>

            {/** P_Technique */}
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox checked={selectedAttrs.ptech} onChange={() => toggleAttr('ptech')}>
                {label[0]?.attributes.P_Technique}
              </Checkbox>
            </FlexboxGrid.Item>

            {/** Made By */}
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox checked={selectedAttrs.madeby} onChange={() => toggleAttr('madeby')}>
                {label[0]?.attributes.MadeBy}
              </Checkbox>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Modal.Body>
        <Modal.Footer>
          {slides.length <= 1 && (
            <>
              {slides[0]?.TempName == 'Format F1' && (
                <Button
                  onClick={() => handleCloseandsave('Format F1')}
                  appearance="primary"
                  color="cyan"
                  loading={loadppt}
                >
                  Ok
                </Button>
              )}
              {slides[0]?.TempName == 'Format F2' && (
                <Button
                  onClick={() => handleCloseandsave('Format F2')}
                  appearance="primary"
                  color="cyan"
                  loading={loadppt}
                >
                  Ok
                </Button>
              )}
              {slides[0]?.TempName == 'Format F3' && (
                <Button
                  onClick={() => handleCloseandsave('Format F3')}
                  appearance="primary"
                  color="cyan"
                  loading={loadppt}
                >
                  Ok
                </Button>
              )}
              {slides[0]?.TempName == 'Format F4' && (
                <Button
                  onClick={() => handleCloseandsave('Format F4')}
                  appearance="primary"
                  color="cyan"
                  loading={loadppt}
                >
                  Ok
                </Button>
              )}
              {slides[0]?.TempName == 'Format F5' && (
                <Button
                  onClick={() => handleCloseandsave('Format F5')}
                  appearance="primary"
                  color="cyan"
                  loading={loadppt}
                >
                  Ok
                </Button>
              )}
              {slides[0]?.TempName == 'Format F6' && (
                <Button
                  onClick={() => handleCloseandsave('Format F6')}
                  appearance="primary"
                  color="cyan"
                  loading={loadppt}
                >
                  Ok
                </Button>
              )}
              {slides[0]?.TempName == 'Format F7' && (
                <Button
                  onClick={() => handleCloseandsave('Format F7')}
                  appearance="primary"
                  color="cyan"
                  loading={loadppt}
                >
                  Ok
                </Button>
              )}
              {slides[0]?.TempName == 'Format F8' && (
                <Button
                  onClick={() => handleCloseandsave('Format F8')}
                  appearance="primary"
                  color="cyan"
                  loading={loadppt}
                >
                  Ok
                </Button>
              )}
            </>
          )}
          {slides.length > 1 && (
            <Button
              onClick={handleCloseandsave}
              appearance="primary"
              color="cyan"
              loading={loadppt}
              disabled={selectedCount < 1}
            >
              Ok
            </Button>
          )}
          {buyercataslide.length <= 1 && (
            <>
              {buyercataslide[0]?.TempName == 'Format F1' && (
                <Button
                  onClick={() => handleCloseandsaveb('Format F1')}
                  appearance="primary"
                  color="cyan"
                  loading={loadppt}
                >
                  Ok
                </Button>
              )}
              {buyercataslide[0]?.TempName == 'Format F2' && (
                <Button
                  onClick={() => handleCloseandsaveb('Format F2')}
                  appearance="primary"
                  color="cyan"
                  loading={loadppt}
                >
                  Ok
                </Button>
              )}
              {buyercataslide[0]?.TempName == 'Format F3' && (
                <Button
                  onClick={() => handleCloseandsaveb('Format F3')}
                  appearance="primary"
                  color="cyan"
                  loading={loadppt}
                >
                  Ok
                </Button>
              )}
              {buyercataslide[0]?.TempName == 'Format F4' && (
                <Button
                  onClick={() => handleCloseandsaveb('Format F4')}
                  appearance="primary"
                  color="cyan"
                  loading={loadppt}
                >
                  Ok
                </Button>
              )}
              {buyercataslide[0]?.TempName == 'Format F5' && (
                <Button
                  onClick={() => handleCloseandsaveb('Format F5')}
                  appearance="primary"
                  color="cyan"
                  loading={loadppt}
                >
                  Ok
                </Button>
              )}
              {buyercataslide[0]?.TempName == 'Format F6' && (
                <Button
                  onClick={() => handleCloseandsaveb('Format F6')}
                  appearance="primary"
                  color="cyan"
                  loading={loadppt}
                >
                  Ok
                </Button>
              )}
            </>
          )}
          {buyercataslide.length > 1 && (
            <Button
              onClick={handleCloseandsaveb}
              appearance="primary"
              color="cyan"
              loading={loadppt}
            >
              Ok
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal open={openattri1} onClose={() => setOpenAttri1(false)}>
        <Modal.Header>
          <Modal.Title>Custom Attributes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FlexboxGrid justify="space-between">
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox checked={productName} onClick={() => setProductName(!productName)}>
                {label[0]?.attributes.ProductName}
              </Checkbox>
            </FlexboxGrid.Item>

            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox checked={productfinish} onClick={() => setProductFinish(!productfinish)}>
                {label[0]?.attributes.finish}
              </Checkbox>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox checked={productntw} onClick={() => setProductNtw(!productntw)}>
                {label[0]?.attributes.NetWgt}
              </Checkbox>
            </FlexboxGrid.Item>

            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox
                checked={productcategory}
                onClick={() => setProductCategory(!productcategory)}
              >
                {label[0]?.attributes.Category}
              </Checkbox>
            </FlexboxGrid.Item>

            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox checked={productdesc} onClick={() => setProductDesc(!productdesc)}>
                {label[0]?.attributes.Description}
              </Checkbox>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleCloseandsave} appearance="primary" color="cyan" loading={loadppt}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal open={opencheck} onClose={handleClosecheck} size="xs" style={{ marginTop: '50px' }}>
        <Modal.Header closeButton={false}>
          <Modal.Title>
            <b>Catalogue is Ready!</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Player autoplay loop src={animati} style={{ height: '300px', width: '300px' }} />
        </Modal.Body>
        <Modal.Footer>
          <Stack justifyContent="center">
            <Button onClick={handleClosecheck} appearance="primary" color="cyan">
              Done
            </Button>
          </Stack>
        </Modal.Footer>
      </Modal>

      <Modal open={openq} onClose={() => setOpenq(false)}>
        <Modal.Header>
          <Modal.Title>
            <b>Link is Ready</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Stack justifyContent="center">
            <QRCode value={qrValue} size={200} />
          </Stack>
        </Modal.Body>
        <Modal.Footer>
          <Button appearance="primary" color="cyan" onClick={() => setOpenq(false)}>
            Done
          </Button>
        </Modal.Footer>
      </Modal>

      <GenerateAuthSlider
        open={openGenerateSlider}
        close={() => setOpenGenerateSlider(false)}
        setLinkGenrate={setLinkGenrate}
        setShowCopyButton={setShowCopyButton}
      />

      <GenerateQrSlider
        open={openWithHeader}
        close={() => setOpenWithHeader(false)}
        setLinkGenrate={setLinkGenrate}
        setQrValue={setQrValue}
        setOpenq={setOpenq}
        setShowCopyButton={setShowCopyButton}
      />
      <Modal open={openFormatModal} onClose={() => setOpenFormatModal(false)} size="xs">
        <Modal.Header>
          <Modal.Title>Select Download Options</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div style={{ display: 'flex', gap: 20 }}>
            {/* Unit */}
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: 12, fontWeight: 500 }}>
                Unit <span style={{ color: 'red' }}>*</span>
              </span>
              <SelectPicker
                data={unitOptions}
                value={selectedUnit}
                onChange={setSelectedUnit}
                placeholder="Select"
                style={{ width: 150 }}
                size="sm"
                searchable={false}
              />
            </div>

            {/* Currency */}
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: 12, fontWeight: 500 }}>Currency</span>
              <SelectPicker
                data={currencyOptions}
                value={selectedCurrency}
                onChange={setSelectedCurrency}
                placeholder="Select"
                style={{ width: 150 }}
                size="sm"
                searchable={false}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            appearance="primary"
            onClick={async () => {
              if (!selectedUnit) return;

              setOpenFormatModal(false);

              if (selectedFormat === 'F1') {
                await handleDownloadPDF(
                  cata,
                  cataloguecatappt,
                  label,
                  data2,
                  watermark,
                  mergeImagesWithWatermark,
                  watermarkUrl,
                  cataName,
                  selectedUnit,
                  selectedCurrency,
                  selectedRate
                );
              }

              if (selectedFormat === 'F2') {
                await handleDownloadPDF2(
                  cata,
                  cataloguecatappt,
                  label,
                  data2,
                  watermark,
                  mergeImagesWithWatermark,
                  watermarkUrl,
                  cataName,
                  catapdf,
                  buyercatapdf,
                  buyername,
                  selectedUnit,
                  selectedCurrency,
                  selectedRate
                );
              }
            }}
          >
            Download
          </Button>

          <Button appearance="subtle" onClick={() => setOpenFormatModal(false)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Generate;
